// Color Variables for consistent theming across the application
// These colors are used in StudentLogin.css and Navbar.css

export const Colors = {
  // Font
  fontFamily: "'Poppins', 'Segoe UI', sans-serif",

  // Primary gradient colors
  primary: '#667eea',
  secondary: '#764ba2',

  // Gradient combinations
  gradientPrimary: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  gradientHover: 'linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%)',

  // Accent colors
  accent: '#facc15',
  accentHover: '#eab308',
  success: '#10b981',
  warning: '#f59e0b',
  danger: '#ef4444',
  info: '#3b82f6',

  // Text colors
  textPrimary: '#374151',
  textSecondary: '#667eea',
  textLight: '#ffffff',
  textMuted: '#6b7280',
  textDark: '#1f2937',

  // Background colors
  bgLight: '#f8f9ff',
  bgLighter: '#f0f2ff',
  bgMain: '#f6f5f7',
  bgWhite: '#ffffff',

  // Border colors
  borderLight: '#e8eaf6',
  borderHover: '#c5cae9',
  borderColor: '#e5e7eb',

  // Shadow
  shadowCard: '0 8px 20px rgba(0,0,0,0.06)',
  shadowHover: '0 12px 30px rgba(0,0,0,0.1)',
  shadowTertiary: 'rgba(102, 126, 234, 0.3)',
  shadowPrimary: 'rgba(102, 126, 234, 0.4)',

  // Button gradient
  btnGradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  btnHover: 'linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%)',

  // Additional colors for Home.css
  gradientAccent: 'linear-gradient(135deg, #facc15 0%, #f59e0b 100%)',
  gradientAccentHover: 'linear-gradient(135deg, #fde047 0%, #facc15 100%)',
  shadowAccent: 'rgba(250, 204, 21, 0.4)',
  shadowAccentHover: 'rgba(250, 204, 21, 0.5)',
  shadowAccent2: 'rgba(250, 204, 21, 0.6)',
  whiteTransparent: 'rgba(255, 255, 255, 0.3)',
  whiteTransparent2: 'rgba(255, 255, 255, 0.5)',
  whiteTransparent3: 'rgba(255,255,255,0.1)',
  whiteTransparent5: 'rgba(255,255,255,0.6)',
  gradientAnimated: 'linear-gradient(90deg, #667eea, #764ba2, #667eea)',
  overlayDark: 'rgba(30, 27, 75, 0.85)',
  overlayPurple: 'rgba(88, 28, 135, 0.7)',
  overlayDark2: 'rgba(30, 27, 75, 0.8)',
  heroOverlayGradient: 'linear-gradient(135deg, rgba(30, 27, 75, 0.85) 0%, rgba(88, 28, 135, 0.7) 50%, rgba(30, 27, 75, 0.8) 100%)',
  shadowPrimaryLight: 'rgba(102, 126, 234, 0.15)',
  shadowPrimary3: 'rgba(102, 126, 234, 0.5)',
  bgAccentLight: '#e0e7ff',
  bgGray: '#f3f4f6',
  bgLightGray: '#f8fafc',
  radialPrimary: 'radial-gradient(circle at 20% 50%, rgba(102, 126, 234, 0.05) 0%, transparent 50%)',
  radialSecondary: 'radial-gradient(circle at 80% 50%, rgba(118, 75, 162, 0.05) 0%, transparent 50%)',
  blackTransparent: 'rgba(0,0,0,0.12)',
  blackTransparent2: 'rgba(0,0,0,0.2)',
};

export default Colors;
